import React from 'react';
import styled from 'styled-components';
import { Breakpoints, BreakpointsPx, ImpNavIcon } from '../..';
import { MaxWidth, spacing } from '../../DesignSystem/design-system';
const CONTAINER_MAX_WIDTH = `min(100vw, ${MaxWidth.Container} )`;
const CONTENT_MAX_WIDTH = `min(100vw, ${MaxWidth.Content} )`;
const Container = styled.div `
  width: ${(props) => (props.widthPx ? `${props.widthPx}px` : '100vw')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;

  ${(props) => props.widthPx &&
    props.widthPx <= BreakpointsPx.Mobile &&
    `
    min-height: ${props.offset ? `calc(100dvh - ${props.offset})` : '100dvh'};
  `}

  @media (max-width: ${Breakpoints.Mobile}) {
    width: 100vw;
    min-height: ${(props) => props.offset ? `calc(100dvh - ${props.offset})` : '100dvh'};
  }
`;
// Contains header, nav bar, body
const TopContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const HeaderContainer = styled.div `
  width: 100%;
`;
const NavContainer = styled.div `
  width: ${(props) => props.widthPx ? `${props.widthPx}px` : CONTAINER_MAX_WIDTH};
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 8px;
  box-sizing: border-box;
`;
const BodyContainer = styled.div `
  width: ${CONTENT_MAX_WIDTH};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: ${(props) => props.customPadding || '0'};
  max-width: ${(props) => props.widthPx ? `${props.widthPx}px` : CONTENT_MAX_WIDTH};

  @media (max-width: ${Breakpoints.Mobile}) {
    padding: 0 ${spacing.xl};
  }
`;
const FooterContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 0 ${spacing.xl} 0;
  align-items: center;
  box-sizing: border-box;
  max-width: ${(props) => props.widthPx ? `${props.widthPx}px` : CONTENT_MAX_WIDTH};

  ${(props) => props.widthPx &&
    props.widthPx <= BreakpointsPx.Mobile &&
    `
    padding: 0 ${spacing.xl} ${spacing.xl};

    & > * {
      width: 100%;
    }
  `}

  @media (max-width: ${Breakpoints.Mobile}) {
    padding: 0 ${spacing.xl} ${spacing.xl};
  }
`;
const ImpActionPage = ({ header, footer, children, widthPx, customPadding, offset, onBackClick, onCloseClick, }) => {
    return (React.createElement(Container, { widthPx: widthPx, offset: offset },
        React.createElement(TopContainer, null,
            header && React.createElement(HeaderContainer, null, header),
            (onBackClick || onCloseClick) && (React.createElement(NavContainer, { widthPx: widthPx },
                onBackClick && React.createElement(ImpNavIcon.Back, { onClick: onBackClick }),
                onCloseClick && React.createElement(ImpNavIcon.Close, { onClick: onCloseClick }))),
            React.createElement(BodyContainer, { widthPx: widthPx, customPadding: customPadding }, children)),
        footer && React.createElement(FooterContainer, { widthPx: widthPx }, footer)));
};
export default ImpActionPage;
//# sourceMappingURL=ImpActionPage.js.map